import { StoreState } from "../store/configureStore";

export type FeatureSourceType = keyof StoreState;

export type FeatureId = { type: FeatureSourceType; id: number, hidePopup?: boolean };

export function unreachable(x: never): never {
  throw new Error(`This should be unreachable! but got ${x}`);
}
